/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2, pxToEm, mediaQuery, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION : ADDON CONTROLLER : STYLES --------------- ++++++++++ */
export default theme => ({
  addoncontroller: {
    width: '100%',
    padding: pxToEm(24),
    minHeight: pxToEm(128),
    background: themeV2.color.base.white,
    borderRadius: pxToEm(12),
      display: 'flex',
      alignItems: 'flex-start',
      '& .cardinner': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        '& .titletoggle': {
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: pxToEm(8),
          '& .toggle': {
            width: pxToEm(40),
            height: pxToEm(22),
            '&.active-false .ball': {
              left: '0.20em'
            },
            '& .ball': {
              height: pxToEm(18),
              width: pxToEm(18)
            }
          },
          '& .title': {
            fontWeight: 'bold',
            color: themeV2.color.primary.main,
            fontSize: pxToEm(16)
          }
        },
        '& .description': {
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: pxToEm(14),
          '& .descriptiontext': {
            position: 'relative',
            fontWeight: 'normal',
            color: themeV2.color.base.gray.dark,
            maxWidth: '75%',
            height: 'auto',
            textOverflow: 'ellipsis',
            paddingRight: pxToEm(5),
            transition: 'max-height .4s',
            textAlign: 'left'
          },
          '& .cta': {
            color: themeV2.color.primary.main,
            marginTop: pxToEm(10)
          },
          '& .cta.name-edit': {
            width: pxToEm(100),
            height: pxToEm(36),
            fontSize: pxToEm(14),
            opacity: 0,
            alignSelf: 'flex-end',
            animationName: 'fadeInUp',
            animationDelay: '.1s',
            animationDuration: '.2s',
            animationFillMode: 'forwards',
            '& .icon i': {
              fontSize: pxToEm(14)
            }
          }
        }
      },
      '& img': {
        margin: replacePXinStringWithEM('8px 32px 0 8px')
      }
  },

  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [mediaQuery.thinnest]: {
    addoncontroller: {
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      textAlign: 'left',
      display: 'block',
      '& .cardinner': {
        '& .description': {
          display: 'block',
          '& .descriptiontext': {
            maxHeight: '100%',
            paddingBottom: pxToEm(12)
          }
        }
      }
    }
  }
});
